var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c("div", { staticClass: "popup-overlay" }, [
        _c("div", { staticClass: "popup" }, [
          _c(
            "button",
            { staticClass: "close-btn", on: { click: _vm.closePopup } },
            [_vm._v("×")]
          ),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup-content" }, [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: "https://24hstore.vn/upload_images/images/Hinh-nen-meo/hinh-nen-meo-cute-dep-ngau-12.jpg",
          alt: "Logo",
        },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "title" }, [_vm._v("계정")]),
      _vm._v(" "),
      _c("p", { staticClass: "message" }, [
        _vm._v("Connecting to your channel..."),
      ]),
      _vm._v(" "),
      _c("button", { staticClass: "loading-btn", attrs: { disabled: "" } }, [
        _vm._v("Please wait..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }